import { render } from "./statsComponent.vue?vue&type=template&id=2a38e7ed&scoped=true"
import script from "./statsComponent.vue?vue&type=script&lang=js"
export * from "./statsComponent.vue?vue&type=script&lang=js"

import "./statsComponent.vue?vue&type=style&index=0&id=2a38e7ed&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a38e7ed"]])

export default __exports__